<template>
    <div id="thx" class="finish">
        <div class="container">
            <div id="thx-title" class="row">
                <div class="col-md-6 offset-md-3">
                    <h1 class="mb-4">{{ $t('finish.title') }}</h1>
                    <h3 class="mb-4" v-if="$route.params.orderId">{{ $t('order') }} #{{ $route.params.orderId }}</h3>
                </div>
            </div>
            <div id="thx-content" class="row" v-if="bankDetails">
                <div class="col-md-8 offset-md-2 my-3">
                    <div v-if="!isMobile" class="table-responsive text-left">
                        <table class="table">
                            <tbody>
                            <tr>
                                <td width="50%" class="text-right">{{ $t('owner') }}</td>
                                <td>{{ bankDetails.owner }}</td>
                            </tr>
                            <tr>
                                <td class="text-right">IBAN</td>
                                <td>{{ bankDetails.iban }}</td>
                            </tr>
                            <tr>
                                <td class="text-right">BIC</td>
                                <td>{{ bankDetails.bic }}</td>
                            </tr>
                            <tr>
                                <td class="text-right">{{ $t('reference_number') }}</td>
                                <td>{{ $route.params.orderId }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <dl v-else>
                        <dt>{{ $t('owner') }}</dt>
                        <dd>{{ bankDetails.owner }}</dd>
                        <dt>IBAN</dt>
                        <dd>{{ bankDetails.iban }}</dd>
                        <dt>BIC</dt>
                        <dd>{{ bankDetails.bic }}</dd>
                        <dt>{{ $t('reference_number') }}</dt>
                        <dd>{{ bankDetails.reference_number }}</dd>
                    </dl>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <p class="mb-5">{{ $t('finish.text') }}</p>
                    <router-link :to="i18nLink('/')" class="btn btn-success mb-5">{{ $t('finish.button') }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .finish {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px;
        min-height: 100vh;
        text-align: center;
        overflow-y: auto;

        .table {

            thead {

                th {
                    border: none;
                }
            }
        }
    }

    body.-is-mobile {

        .finish {
            position: static;
            width: 100%;
            height: auto;
            top: auto;
            left: auto;
            padding: 30px 20px;
        }
    }
</style>

<script>
  import finishPage from 'src/mixins/finishPage';

  export default {
    mixins: [finishPage],
  };
</script>